<div class="modal-header">
  <h5 class="modal-title">{{title}}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="onClickCancel()" ></button>
</div>
<div class="modal-body">
  <div class="container">
    <div class="form-group row">
      <label class="form-control-label">Report Type</label>
      <select class="form-control" class="form-control" [(ngModel)]="reportType">
        @for (reportType of reportTypes; track reportType) {
          <option [ngValue]="reportType">{{reportType.name}}</option>
        }
      </select>
    </div>
    <div class="form-group row">
      <label class="form-control-label">Description</label>
      <input class="form-control" type="text" [(ngModel)]="description"/>
    </div>
  </div>
</div>
<div class="modal-footer">
  <label class="btn btn-primary btn-file" [ngClass]="{'disabled': !reportType}">
    <span class="fa fa-cloud-upload"></span> Select File to Upload <input type="file" hidden (change)="onClickUpload($event)" [disabled]="!reportType" accept=".pdf,.doc,.docx">
  </label>
</div>
